import { createSelector } from 'reselect';

export const routesDomainSelector = state => state.routes;

export const routesSelector = createSelector(
  routesDomainSelector,
  subState => [...subState.data]
);

export const routeSelectedSelector = createSelector(
  routesSelector,
  subState => {
    const route = subState.filter(item => item.selected === true || item.routeStyleHide === true)[0];

    if (route?.routeStyleHide) {
      return {
        ...route,
        startPoint: {},
      };
    }
    return route;
  }
);

export const isRoutesFetchingSelector = createSelector(
  routesDomainSelector,
  subState => subState.fetching
);
